import apiClient from './axios';

/**
 * 랭킹 데이터
 */
export interface RankingData {
  nickname: string;
  totalCount: string;
}

/**
 * 랭킹 응답
 */
export interface RankingResponse {
  getLastRanking: RankingData[];
  getThisRanking: RankingData[];
}

/**
 * 랭킹 조회 파라미터
 */
export interface RankingParams {
  _targetDate_past15: string;
  _targetDate_14: string;
  _targetDate_15: string;
  _targetDate_post14: string;
}

/**
 * 월간 랭킹 조회
 */
export const getRanking = async (params: RankingParams): Promise<RankingResponse> => {
  const response = await apiClient.get<RankingResponse>('/api/schedules/ranking', { params });
  return response.data;
};

/**
 * 랭킹 조회를 위한 날짜 계산
 * 15일 기준으로 지난달/이번달 랭킹 기간 계산
 */
export const calculateRankingDates = () => {
  const today = new Date();
  const currentDayOfMonth = today.getDate();
  let targetDate: Date;

  if (currentDayOfMonth <= 15) {
    // 오늘이 15일 이전인 경우, 저번 달의 15일을 반환
    targetDate = new Date(today.getFullYear(), today.getMonth() - 1, 15);
  } else {
    // 오늘이 15일 이후인 경우, 이번 달의 15일을 반환
    targetDate = new Date(today.getFullYear(), today.getMonth(), 15);
  }

  // Date 객체를 문자열로 포맷팅
  const formatDate = (date: Date, time: string) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day} ${time}`;
  };

  // 지난달 15일 00:00:00
  const past15Date = new Date(targetDate.getFullYear(), targetDate.getMonth() - 1, targetDate.getDate());
  const targetDate_past15 = formatDate(past15Date, '00:00:00');

  // 이번달 14일 23:59:59
  const date14 = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate() - 1);
  const targetDate_14 = formatDate(date14, '23:59:59');

  // 이번달 15일 00:00:00
  const targetDate_15 = formatDate(targetDate, '00:00:00');

  // 다음달 14일 23:59:59
  const post14Date = new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, targetDate.getDate() - 1);
  const targetDate_post14 = formatDate(post14Date, '23:59:59');

  // 표시용 날짜 범위 계산
  const formatRange = (date: Date) => {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}`;
  };

  const lastMonthRange = `${formatRange(past15Date)} ~ ${formatRange(date14)}`;
  const thisMonthRange = `${formatRange(targetDate)} ~ ${formatRange(post14Date)}`;

  return {
    params: {
      _targetDate_past15: targetDate_past15,
      _targetDate_14: targetDate_14,
      _targetDate_15: targetDate_15,
      _targetDate_post14: targetDate_post14,
    },
    lastMonthRange,
    thisMonthRange,
  };
};
